export const edproTeachers = function() {
		$(".js-teachers-all").on("click", function(event) {
				$(this).parent().toggleClass('open');
		});

}
export const edproGraduates = function() {
	$(".js-graduates-all").on("click", function(event) {
			$(this).parent().parent().toggleClass('open');
	});
}

export const edproAlerts = function() {
	const alertClose = document.querySelector('.js-alerts-close')
	alertClose.addEventListener('click', function(event) {
		if (event.target.closest('.js-alerts-close')) {
			event.target.closest('.js-alerts-close').closest('.js-alerts').style.display = 'none'
		}
	})
}

export const edproAuthor = function() {
    $(".js-author-mob").on("click", function(event) {
        $(this).parent().toggleClass('open');
    });
}

export const edproAnchor = function() {


    $('a.anchor[href*="#"]').on('click', function() {
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 400);
        return false;
    });

}